import { Outlet, useNavigate, useParams } from 'react-router-dom'

import { AvailableModules } from 'generated/featureDefinitions'
import { GetModuleAvailabilitiesDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { isModuleAvailabilityEnabled } from 'modules/core/lib/isModuleAvailabilityEnabled'

import CollectionsBootstrap from 'modules/trainings/lib/ContentCollectionsBootstrap'

const ContentRoot = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { id } = useParams()

  const {
    company: { id: companyId },
  } = useCurrentSession()

  const { data: featureData, loading: loadingModuleAvailability } = useQuery(
    GetModuleAvailabilitiesDocument,
    {
      fetchPolicy: 'cache-first',
      variables: {
        ids: [AvailableModules.lms],
        companyId,
      },
    }
  )

  const moduleAvailabilities = featureData?.companies.moduleAvailabilities ?? []
  const hasLMSModule = isModuleAvailabilityEnabled(moduleAvailabilities, AvailableModules.lms)

  const hasContentFF = hasLMSModule

  if (loadingModuleAvailability) {
    return
  }

  if (!hasContentFF) {
    navigate(navigation.trainings.list.details_revamp.view.overview.fullPath({ id: Number(id) }))
  }

  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default ContentRoot
